export const role_permission= {
    requried_permission:['view_role', 'add_role', 'change_role', 'delete_role', 'view_vertical', 'view_employeelevel', 'add_employeelevel', 'view_competency', 'add_competency', 'view_responsibility', 'add_responsibility', 'view_eligibility', 'add_eligibility', 'view_education', 'add_education', 'change_education', 'delete_education'],
    view_role:['view_role','view_employeelevel','view_competency','view_responsibility','view_eligibility','view_education'],
    delete_role:['delete_role'],
    edit_role:['change_role'],
    delete_eligibility_permission:['view_eligibility','delete_eligibility'],
    change_eligibility_permission:['view_eligibility','change_eligibility']
}